import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormService } from 'src/app/core/form.service';
import { Store, StoresService } from 'src/app/core/stores.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-stores-plugin-credentials-dialog',
  templateUrl: './stores-plugin-credentials-dialog.component.html',
  styleUrls: ['./stores-plugin-credentials-dialog.component.scss'],
})
export class StoresPluginCredentialsDialogComponent {
  store?: Store;
  is_set_plugin_credentials_running: boolean = false;
  store_plugin_credentials_form_group: FormGroup = this.form_service.store_plugin_credentials_form_group;
  is_secret_visible: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<StoresPluginCredentialsDialogComponent>,
    private stores_service: StoresService,
    private error_service: ErrorService,
    private utils_service: UtilsService,
    private form_service: FormService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.store = data.store;
  }

  ngOnInit(): void {
    this.store_plugin_credentials_form_group.get(this.form_service.client_id_label)?.disable();
    this.store_plugin_credentials_form_group.get(this.form_service.client_secret_label)?.disable();

    this.store_plugin_credentials_form_group.get(this.form_service.client_id_label)?.setValue(this.store?.client_id);
    this.store_plugin_credentials_form_group
      .get(this.form_service.client_secret_label)
      ?.setValue(this.store?.client_secret);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (!this.is_set_plugin_credentials_running && this.store?.store_id) {
      this.setPluginCredentials(this.store.store_id);
    }
  }

  onCopyClick(content_type: string): void {
    const content = content_type == 'client_id' ? this.store?.client_id : this.store?.client_secret;
    this.utils_service.copyClick(content);
  }

  setPluginCredentials(store_id: string): void {
    this.is_set_plugin_credentials_running = true;
    this.stores_service.setPluginCredentials(store_id).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_set_plugin_credentials_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_set_plugin_credentials_running = false;
      },
    });
  }
}
